import React from "react";

function AnimatedCTA({ href, children, className = "", mobile = false, full = false }) {
  return (
    <a
      href={href}
      className={`banner-cta group ${mobile ? "h-[48px]" : "h-[44px]"} ${full ? "!flex w-full" : ""} ${className}`}
    >
      <span className={`banner-cta-label ${mobile ? "px-[28px] text-[15px]" : "px-[30px] text-[14px]"} ${full ? "flex-1" : ""}`}>
        {children}
      </span>
      <span className={`${mobile ? "w-[48px] h-[48px]" : "w-[44px] h-[44px]"} banner-cta-circle`}>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M3 9H14M10 5L14 9L10 13"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </a>
  );
}

export default AnimatedCTA;
